// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ls-0";
export var fileCarousel = "_ls-2";
export var removeFileButton = "_ls-1";